/* Copyright (c) 2022 Xperi. All Rights Reserved. */

export class MediaButtonClasses {
    static PLAY: string = 'play';

    static PAUSE: string = 'pause';

    static START_FROM_BUFFER: string = 'start-from-buffer';

    static REPLAY: string = 'replay';

    static REWIND: string = 'rewind';

    static FORWARD: string = 'forward';

    static ADVANCE: string = 'advance';

    static GO_TO_LIVE: string = 'go-to-live';

    static LIVE: string = 'live';

    static INFO: string = 'info';
}
